import React from "react";
import DatePickerInput from "../DatePickerInput";
import DatePicker from "react-datepicker";

export const DateSelect = ({ value, onChange, dates }) => {
    const uniq = (value, index, self) => self.indexOf(value) === index;
    const enabledDays = dates.filter(item => item).filter(uniq).map(({ date }) => date);
    return window.innerWidth <= 760 ?
        <DatePicker
            dateFormat="dd.MM.yyyy"
            placeholderText='Ønsket dato'
            selected={value}
            locale="nb"
            onChange={onChange}
            customInput={<DatePickerInput />}
            portalId="bookingMapContainer"
            includeDates={enabledDays || []}
            withPortal
        /> : <DatePicker
            dateFormat="dd.MM.yyyy"
            placeholderText='Ønsket dato'
            selected={value}
            locale="nb"
            onChange={onChange}
            includeDates={enabledDays || []}
            popperModifiers={{
                preventOverflow: {
                    enabled: true,
                },
            }}
            customInput={<DatePickerInput />}
        />
}